<template>
  <div class="sc-grid-layout" :style="gridTemplateColumns">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'sc-grid-layout',
  props: {
    columns: {
      type: Number,
      default: 2,
    },
    minWidth: {
      type: String,
      default: '320px',
    },
    maxWidth: {
      type: String,
      default: '1fr',
    },
  },
  data() {
    return {
      windowWidth: 0,
    };
  },
  computed: {
    gridTemplateColumns() {
      const cols = this.windowWidth > 764 ? this.columns : 1;
      const minWidth = this.windowWidth > 764 ? this.minWidth : '200px';

      return {
        gridTemplateColumns: `repeat(${cols}, minmax(${minWidth}, ${this.maxWidth}))`,
      };
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
};
</script>

<style lang="scss" scoped>
.sc-grid-layout {
  border-top: 1px solid #e7e7e7;
  border-right: 1px solid #e7e7e7;
  display: grid;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-ctes/components/ScGridLayout.vue